import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";

interface DuesBalanceResponse {
  apiVersion: string;
  status: string;
  data: {
    walletCreated: boolean;
    captainId: string;
    balance: number;
    breakup: {};
  };
}

@Injectable()
export class CaptainRedeemService {
    constructor(public httpClient: HttpClient) { }

    async getWalletCaptainPassbookFromWallet(id: string, requestBody: Object, pageSize: number, next: string, prev: string ): Promise<any> {
        const url = `${environment.server}/api/riderwallet/captainPassbook`;
        const result = await this.httpClient.get(url, {
            params: { riderId:id.toString(), requestBody:JSON.stringify(requestBody), pageSize: pageSize.toString(), next: next.toString(), prev:prev.toString() }
        }).toPromise();
        return result;
    }

    async getAutopayStatusDetails(captainId: string, serviceDetailIds: Array<string>, latitude: number, longitude:number) {
        const url = `${environment.server}/api/autopay/statusInfo`;
        const result = await this.httpClient.get(url, {
            params: { riderId:captainId.toString(), serviceDetailIds:JSON.stringify(serviceDetailIds), lat:latitude.toString(), lng:longitude.toString() }
        }).toPromise();
        return result;
      }

    async getCoinBalanceDetails(captainId: string, serviceDetailIds: Array<string>, latitude: number, longitude:number) {
        const url = `${environment.server}/api/coinIncentive/balance`;
        const result = await this.httpClient.get(url, {
            params: { riderId:captainId.toString(), serviceDetailIds:JSON.stringify(serviceDetailIds), lat:latitude.toString(), lng:longitude.toString() }
        }).toPromise();
        return result;
      }

    async getCoinIncentivePassbookDetails(id: string, requestBody: Object): Promise<any> {
        const url = `${environment.server}/api/coinIncentive/passbook`;
        const result = await this.httpClient.get(url, {
            params: { riderId:id.toString(), requestBody:JSON.stringify(requestBody)}
        }).toPromise();
        return result;
      }

    async getCaptainDuesTransactions(captainId: string, requestBody: Object, pageSize: number, next: string, prev: string): Promise<any> {
        const url = `${environment.server}/api/${captainId}/dues/transactions`;
        const result = await this.httpClient.get(url, {
            params: { riderId: captainId, requestBody: JSON.stringify(requestBody), pageSize: pageSize.toString(), next: next.toString(), prev: prev.toString() }
        }).toPromise();
        return result;
    }

    async getCaptainDuesBalance(captainId: string): Promise<DuesBalanceResponse> {
        const result = await this.httpClient.get<DuesBalanceResponse>(`${environment.server}/api/${captainId}/dues/balance`).toPromise();
        return result;
    }
}
